import {
  CLOUD_SOURCE_UNAVAILABLE_REASON,
  DROPBOX_UNCONFIGURED_REASON,
  EASY_MODE_CLOUD_SOURCE,
  EASY_MODE_CLOUD_SOURCES,
  ONE_DRIVE_UNCONFIGURED_REASON
} from '../constants/easyModeIntegrations';
import useEasyModeDropboxImport from './useEasyModeDropboxImport';
import useOneDriveImport from './useOneDriveImport';

const useEasyModeCloudSources = ({ onFilesReady }) => {
  const dropbox = useEasyModeDropboxImport({ onFilesReady });
  const oneDrive = useOneDriveImport({ onFilesReady });

  const providerBySource = {
    [EASY_MODE_CLOUD_SOURCE.DROPBOX]: { provider: dropbox, unconfiguredReason: DROPBOX_UNCONFIGURED_REASON },
    [EASY_MODE_CLOUD_SOURCE.ONE_DRIVE]: { provider: oneDrive, unconfiguredReason: ONE_DRIVE_UNCONFIGURED_REASON }
  };

  return EASY_MODE_CLOUD_SOURCES.map((source) => {
    const match = providerBySource[source.value];

    if (!match) {
      return {
        ...source,
        label: source.text,
        isAvailable: false,
        isDisabled: true,
        unavailableReason: CLOUD_SOURCE_UNAVAILABLE_REASON,
        onClick: null
      };
    }

    const { provider, unconfiguredReason } = match;

    return {
      ...source,
      label: provider.isImporting ? 'Importing...' : source.text,
      isAvailable: provider.isEnabled,
      isDisabled: !provider.isEnabled || !provider.isReady || provider.isImporting,
      unavailableReason: unconfiguredReason,
      onClick: provider.openPicker
    };
  });
};

export default useEasyModeCloudSources;
